import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Button,
  Dropdown,
  NavDropdown,
  Nav,
} from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { ASYNC_USER_LOGOUT } from 'store';
import history from '../../pages/history';
import style from './style.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as facebook from '../../images/social/facebook.png';
import * as instagram from '../../images/social/instagram.png';
import * as linkedin from '../../images/social/linkedin.png';
import * as spotify from '../../images/social/spotify.png';
import * as youtube from '../../images/social/youtube.png';
import * as telegram from '../../images/social/telegram.png';

import * as logoScanSelect from '../../images/logo/logo_scansource_select_colorido.png'
import * as logoElitePass from '../../images/logo/logo_elite_pass.png'

import {
  faBars,
  faSignOutAlt,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

import './style.css';
import AlertNotification from 'components/AlertNotification';
import { Badge } from '@material-ui/core';
import LoginService from 'services/login';

import { useCompany, useProfile, useUser } from 'models';
import UserAvatar from 'components/UserAvatar';
import Storage from 'helpers/storage';
import { AdminProfiles, FY23, FY24, FY25, MasterAgentProfiles, ProfileType } from 'helpers/Enum';

const Header = ({ collapsed, setCollapsed, countNotification }) => {
  const user = useUser();
  const profile = useProfile();
  const fiscalYear = JSON.parse(localStorage.getItem("Elite:fiscalYear")) ?? {}
  const { company, setCompany } = useCompany();
  const [isUserBoxOpen, setOpenUserBox] = useState('hide');

  const getUsername = () => {
    return user.name;
  };

  const getProfile = () => {
    return profile.name
  };

  const isElite = () => {
    return user.isElite()
  };

  const isMasterAgent = () => {
    return user.isMasterAgent()
  };

  const isActive = useLocation().pathname;

  const hasMoreThenOneResaleCompany = () => {
    return user.companies.filter(c => c.company_type_id === 2).length > 1
  }

  const getCompanyName = () => {
    return !!company ? (
      <li className={style.vendorName + ' align-middle'}>
        <p className="company-name">
          <strong>
            Cliente:
            <br />
          </strong>
          <span style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%',
            display: 'inline-block',
            height: '15px'
          }}>
            {(() => {
              let name = company.company_name
              if (name.length > 25) {
                name = name.substring(0, 25) + "..."
              }
              return name;
            })()}
          </span>
          <br />
          {!!Storage.get("company") || hasMoreThenOneResaleCompany() ? (
            <Button
              className={
                'btn-secondary ' +
                style.btnSecondaryGrey +
                ' waves-effect btn-xs'
              }
              size="sm"
              onClick={() => {
                setCompany(null)
                localStorage.removeItem("Elite:fiscalYear")
                localStorage.removeItem("Elite:ignoreNotification")
                window.location.href = '/companies';
              }}
            >
              Voltar
            </Button>
          ) : (
            ''
          )}
        </p>
      </li>
    ) : (
      <></>
    );
  };

  const openUserBox = () => {
    setOpenUserBox(isUserBoxOpen === 'show' ? 'hide' : 'show');
  };

  const logout = async () => {
    try {
      await LoginService.logout();
    } catch (error) {
    } finally {
      localStorage.clear();
      window.location.reload();
    }
  };

  const showProgramasOption = () => {
    const cc = JSON.parse(localStorage.getItem('currentCompany'))
    if (cc) {
      if (!profile.havePermission('elite.index') && cc.premium && !cc.masteragent)
        return false;
    }

    return true
  }

  const handleClickFiscalYear = async (fy) => {
    await new Promise((resolve) => {
      localStorage.setItem("Elite:fiscalYear", JSON.stringify(fy))
      resolve(true)
    })

    window.location.reload()
  }

  const showFiscalYear = () => {
    const getYearsWithoutBlock = () => {
      if (AdminProfiles.includes(profile.id)) {
        
        if (!!company.adhesion) {
          // console.log(company)
          return company.adhesion.map(item => item.fiscal_year).filter(year => !year.block)
        }
        
        return company.fiscal_year.reverse()
      }

      if (!company.headquarter) {
        return company.fiscal_year.filter(year => !year.block)
      }

      if (!company.adhesion) {
        return company.fiscal_years_elite.filter(year => !year.block)
      }
      return company.adhesion.map(item => item.fiscal_year).filter(year => !year.block)
    }

    const selectFiscalYear = (years) => {
      return (
        <Nav>
          <NavDropdown id="nav-dropdown">
            {years.filter(year => year.id != fiscalYear.id).map(year => (
              <NavDropdown.Item onClick={() => handleClickFiscalYear(year)}>
                {year.fiscal_year}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </Nav>
      )
    }


    const fiscalYearsWithoutBlock = getYearsWithoutBlock()

    if ('fiscal_year' in fiscalYear) {
      return (
        <div className='d-flex align-items-center justify-content-center'>
          <span>{fiscalYear.fiscal_year}</span>
          {fiscalYearsWithoutBlock.length > 1 && selectFiscalYear(fiscalYearsWithoutBlock)}
        </div>
      )
    } else {
      return (
        <span>{fiscalYearsWithoutBlock[fiscalYearsWithoutBlock.length - 1].fiscal_year}</span>
      )
    }
  }

  const dashboardLabel = () => {
    if (company && [1, 3, 4, 5].includes(company.is_premium) || !company && AdminProfiles.includes(profile.id)) {
      return 'Dashboard'
    }

    if (!company && MasterAgentProfiles.includes(profile.id) || company && company.isMasterAgent()) {
      return 'Master Agent'
    }
  }

  useEffect(() => {
    showProgramasOption()
  }, [isUserBoxOpen]);

  const minWidth = 940;
  const isMobile = window.innerWidth <= minWidth;

  return (
    <>
      <header
        className={
          collapsed
            ? 'header-user-collapsed '
            : 'header-user'
        }
        id="menu-top-1"
      >
        <Row className="justify-content-between w-100 h-100 m-0">
          <Col xs="auto" className="h-100">
            <Row className="h-100 align-items-center">
              <Col sm="auto" md="auto" lg="auto">
                <div className="menu-icon">
                  <Badge badgeContent={countNotification} color="secondary" max={9} variant="dot">
                    <FontAwesomeIcon className="" icon={faBars} onClick={() => setCollapsed(!collapsed)} />
                  </Badge>
                </div>
              </Col>
              <Col sm="auto" md="auto" lg="auto" className="col-social pl-0"
                style={{ display: isMobile ? 'none' : '' }}
              >
                <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/ScanSourceBR/">
                  <img src={facebook} className="menu-social" alt="" height="23" />
                </a>
                <a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/scansourcebr/">
                  <img src={instagram} className="menu-social" alt="" height="23" />
                </a>
                <a rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.linkedin.com/company/scansource-brasil"
                >
                  <img src={linkedin} className="menu-social" alt="" height="23" />
                </a>
                <a rel="noopener noreferrer"
                  target="_blank"
                  href="https://open.spotify.com/show/2GHIaHdjjiBDnycUW1uJMu?si=BHERnGFwQ9azpR7xqusphg"
                >
                  <img src={spotify} className="menu-social" alt="" height="23" />
                </a>
                <a rel="noopener noreferrer" target="_blank" href="https://www.youtube.com/user/ScanSourceBR">
                  <img src={youtube} className="menu-social" alt="" height="23" />
                </a>
                <a rel="noopener noreferrer" target="_blank" href="https://t.me/joinchat/Vld1KDMlIUyVL5CH">
                  <img src={telegram} className="menu-social" alt="" height="23" />
                </a>
              </Col>
            </Row>
          </Col>
          <Col xs="auto" className="h-100">
            <Row className="h-100 align-items-center">
              {company ? (() => {
                let r = [];
                if (company.isMasterAgent()) r.push(<Col xs="auto" key={1}><h5>Master Agent</h5></Col>)
                if(fiscalYear.id == 13){
                  if (company.getYearData(fiscalYear.id).isElitePass()) r.push(<Col xs="auto" key={2}><img src={logoElitePass} className="" alt="scancash" height="50" /></Col>)
                } else {
                  if (company.getYearData(fiscalYear.id).isScanSourceSelect()) r.push(<Col xs="auto" key={2}><img src={logoScanSelect} className="" alt="scancash" height="50" /></Col>)
                }
                return r;
              })() : <></>}
            </Row>
          </Col>
          <Col xs="auto" className="h-100">
            <Row style={{ height: '100%' }}>
              {/* {!!company && (company.isScanSourceSelect()) && (
                <Col sm="auto" md="auto" lg="auto" className="d-flex flex-column list-unstyled topnav-menu float-right mb-0" style={{ width: isMobile ? '190px' : '' }}>
                  <span className='font-weight-bold' style={{ fontSize: '12px' }}>Ano Fiscal:</span>
                  {showFiscalYear()}
                </Col>
              )} */}
              <Col sm="auto" md="auto" lg="auto" className="list-unstyled topnav-menu float-right mb-0"
                style={{ width: isMobile ? '190px' : '', overflow: 'hidden' }}
              >
                {getCompanyName()}
              </Col>
              {isMobile ? '' : (
                <Col xs="auto" className='h-100 p-0'>
                  <AlertNotification />
                </Col>
              )}
              <Col sm="auto" md="auto" lg="auto" className={"pl-0 right-align" + (() => {
                if (company) {
                  if (company.isElite()) return " col-user-area"
                  let n = 0;
                  if (company.isMasterAgent()) n++
                  if (company.isScancash()) n++
                  if (n == 2) return " col-user-area"
                }
                return "";

              })()} style={{
                minWidth: isMobile ? '72px' : '210px',
                width: isMobile ? '72px' : '210px'
              }}>
                <ul className={'list-unstyled topnav-menu user-area row'} onClick={openUserBox}>
                  <div className="header-user-img-container col-auto p-0">
                    <UserAvatar user={user} style={{ marginRight: -8 }} />
                  </div>
                  <li className="dropdown notification-list col p-0" style={{ width: "172px" }}>
                    <a rel="noopener noreferrer"
                      className="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"
                      data-toggle="dropdown"
                      href="#"
                      role="button"
                      aria-haspopup="false"
                      aria-expanded="false"
                      onClick={openUserBox}
                    >
                      <span className="pro-user-name ml-1" style={{ display: isMobile ? 'none' : '' }}>
                        {getUsername()}
                        <i className="mdi mdi-chevron-down"></i>
                      </span>
                    </a>
                    <span className="col-12 header-user-profile mt-2" style={{ display: isMobile ? 'none' : '' }}>
                      {getProfile()}
                    </span>
                    <ul
                      className={`dropdown-menu dropdown-menu-right profile-dropdown ${isUserBoxOpen}`}
                    >
                      <li className="dropdown-header noti-title">
                        <p className="text-overflow m-0">Bem-vindo(a)</p>
                      </li>
                      <Button
                        variant="link"
                        className="dropdown-item notify-item"
                        onClick={() => history.push('/account')}
                        style={{ color: "#212529", fontWeight: "normal" }}
                      >
                        <FontAwesomeIcon
                          icon={faUser}
                          size="sm"
                          style={{ marginRight: '5px' }}
                        />
                        <span> Minha Conta </span>
                      </Button>
                      <a rel="noopener noreferrer"
                        href="#"
                        className="dropdown-item notify-item"
                        onClick={logout}
                      >
                        <FontAwesomeIcon
                          icon={faSignOutAlt}
                          size="sm"
                          style={{ marginRight: '5px' }}
                        />
                        <span> Logout </span>
                      </a>
                    </ul>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </header>
      <div className={(collapsed ? 'navbar-custom-collapsed' : 'navbar-custom') + (isMobile ? ' navbar-custom-mobile' : '')}
        id="menu-top-2"
      >
        <Link to="/" className={`topmenu-item ${isActive === '/' ? 'active' : ''}`}>
          {dashboardLabel()}
          {/* {(!!company && [1, 3, 4].includes(company.is_premium)) ? 'ScanSource Select' : 'Master Agent'} */}
        </Link>
        {showProgramasOption() ? (
          <Link to="/programs" className={`topmenu-item ${isActive === '/programs' ? 'active' : ''}`}>
            {(!!company && [1, 3, 4].includes(company.is_premium)) ? 'Resgates' : 'Programas'}
          </Link>
        ) : (<></>)}
        <Link
          to="/events"
          className={`topmenu-item ${isActive === '/events' ? 'active' : ''}`}
        >
          Eventos
        </Link>
        <Link
          to="/education"
          className={`topmenu-item ${isActive === '/education' ? 'active' : ''}`}
        >
          Educação
        </Link>

        {profile.havePermission('faq.index') && isElite() ? (
          <Link
            to="/faq-elite"
            className={`topmenu-item ${isActive === '/faq-elite' ? 'active' : ''}`}
          >
            Dúvidas Frequentes - Elite
          </Link>
        ) : (<></>)}

        {profile.havePermission('faq-master-agent.index') && isMasterAgent() ? (
          <Link
            to="/faq-master-agent"
            className={`topmenu-item ${isActive === '/faq-master-agent' ? 'active' : ''}`}
          >
            Dúvidas Frequentes - Master Agent
          </Link>
        ) : (<></>)}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch({ type: ASYNC_USER_LOGOUT }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
